import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

import App from './App';
import './index.css';
import './i18n';
import { setupGlobalChunkErrorHandler } from './utils/lazyWithRetry';

// Setup global error handlers for chunk loading failures
setupGlobalChunkErrorHandler();

/** Load first-party gtag bootstrap after window load + idle — keeps parse/eval off the critical path (TBT). */
function scheduleDeferredGtagInitScript(): void {
  if (typeof window === 'undefined') return;
  const inject = () => {
    if (document.getElementById('gtag-init-bootstrap')) return;
    const s = document.createElement('script');
    s.id = 'gtag-init-bootstrap';
    s.src = '/js/gtag-init.js';
    s.async = true;
    document.head.appendChild(s);
  };
  const afterLoad = () => {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(() => inject(), { timeout: 12000 });
    } else {
      setTimeout(inject, 2500);
    }
  };
  if (document.readyState === 'complete') {
    afterLoad();
  } else {
    window.addEventListener('load', afterLoad, { once: true });
  }
}
scheduleDeferredGtagInitScript();

const rootElement = document.getElementById('root');
if (rootElement) {
  createRoot(rootElement).render(
    <StrictMode>
      <HelmetProvider>
        <Router>
          <App />
        </Router>
      </HelmetProvider>
    </StrictMode>
  );
}